if (!customElements.get('scroll-reviews')) {
  class ScrollReviews extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init () {
      this.settings = {
        reviews: this.querySelectorAll(".scroll-review"),
      };

      window.addEventListener("scroll", () => {
        this.settings.reviews.forEach(review => {
          const blockSettings = review.getBoundingClientRect();
          const stepBottom = blockSettings.top - window.innerHeight + blockSettings.height / 2;
          if (stepBottom < 0) {
            review.style.opacity = 1;
          } else {
            review.style.opacity = 0;
          }
        });
      });
    }
  }

  customElements.define('scroll-reviews', ScrollReviews);
}
